<app-organizer-shared-form-wrapper
  class="organizer-activity-creation-page-title"
  [activeStep]="1"
  [error$]="error$"
  [formGroup]="formGroup"
  [sectionDescription]="
    'activity_creation.title.section.description' | translate
  "
  [sectionTitle]="'activity_creation.title.section.title' | translate"
  [tipsConfig]="tipsConfig"
  (formSubmit)="submit($event)"
>
  <app-form-input-group
    [label]="
      'activity_creation.title.title.label'
        | translate: { maxLength: titleDefaultMaximumCharacters }
    "
    [title]="'activity_creation.title.title.title' | translate"
    [errors]="titleErrors"
    errorKey="title"
  >
    <app-form-textarea
      #content
      formControlName="title"
      [placeholder]="'activity_creation.title.title.placeholder' | translate"
      [rows]="3"
      [required]="true"
      [maxLength]="titleDefaultMaximumCharacters"
    ></app-form-textarea>
  </app-form-input-group>
</app-organizer-shared-form-wrapper>
